<template>
  <v-container 
  class="dt-sidenav-tab overview"
  :class="[bookingOverview.dataState]"
  fluid>
  <grid-layout
    class="dt-grid-layout"
    :layout="gridLayout.layout"
    :col-num="gridLayout.columnNumber"
    :row-height="gridLayout.rowHeight"
    :is-draggable="gridLayout.isDraggable"
    :is-resizable="gridLayout.isResizable"
    :is-mirrored="gridLayout.isMirrored"
    :vertical-compact="gridLayout.verticalCompact"
    :margin="gridLayout.margin"
    :use-css-transforms="gridLayout.useCssTransforms"
    ref="gridLayout"
    >

      <grid-item
        v-bind="gridLayout.layout[0]"
        >
        <BoxWidget 
        :isPinnable="true" 
        @pin="onBoxPinned" 
        @selected="selectBox"
         @minimized="onMinimize" 
         @maximized="onMaximize" 
         :layoutItem="gridLayout.layout[0]" >
          <Artists

            @artist_calendar_date_selected="onArtistCalendarDateSelected"
          />
        </BoxWidget>
        
      </grid-item>




    </grid-layout>

    <!-- <template v-if="artistCalendarDateModalContainer">

      <v-dialog 
        persistent
        v-model="artistCalendarDateModal"      
        width="1000"
      >
        <ArtistCalendarDate
          :artistCalendarDateProp="artistCalendarDateProp"

          @done="onArtistCalendarDone"
          @cancelled="onArtistCalendarDateModalCancel"
        />

      </v-dialog>

    </template> -->

    <template v-if="addArtistModalContainer && calendarDate">

      <v-dialog 
        persistent
        v-model="addArtistModal"      
        width="800"
      >
        <AddArtist
          :calendarDate="calendarDate"
          :calendarDateId="calendarDateId"

          @done="addArtistModalDone"
          @cancelled="addArtistModalCancelled"
        />

      </v-dialog>

    </template>
    <template v-if="addTaskModalContainer && calendarDate">

      <v-dialog 
        persistent
        v-model="addTaskModal"      
        width="800"
      >
        <AddTask
          :calendarDateId="calendarDateId"
          :users="users"

          @done="onAddTaskDone"
          @cancelled="addTaskModalCancelled"
        />

      </v-dialog>

    </template>
    <template v-if="addInvoiceLineModalConainer && calendarDate">

      <v-dialog 
        persistent
        v-model="addInvoiceLineModal"      
        width="800"
      >
        <AddInvoiceLine
          :calendarDateId="calendarDateId"
          
          @done="doneAddInvoiceLine"
          @cancelled="addInvoiceLineModalCancelled"
        />

      </v-dialog>

    </template>
    <template v-if="createInvoiceModalConainer && calendarDate">

      <v-dialog 
        persistent
        v-model="createInvoiceModal"      
        width="800"
      >
        <CreateInvoice
          :calendarDateId="calendarDateId"
          
          @done="doneCreateInvoice"
          @cancelled="createInvoiceModalCancelled"
        />

      </v-dialog>

    </template>

  </v-container>
</template>

<script>

import { createNamespacedHelpers, mapMutations } from 'vuex';

import VueGridLayout from 'vue-grid-layout';

import BoxWidget from '@plugins/box-widget/box-widget';

import Artists from '../../../booking-sidewindow/artists';

// import Checklist from './checklist';
// import CustomChecklist from './custom-checklist';
// import Tasks from './tasks';
// import Deal from './deal';
// import Notes from './notes';

// import Invoicing from '../money-details/invoicing';

// import EventDetailsArtists from '../event-details/artists';
// import LocalInfos from '../event-details/local-infos';
// import EventDetails from '../event-details/event-details';
// import LineUp from '../event-details/line-up';


// import TemplateSelection from '../documents/template-selection';
// import DocumentTable     from '../documents/document-table'    ;
// import Files             from '../documents/files'             ;


// import TravelBefore from '../travel-details/travel-before';
// import TravelAfter from '../travel-details/travel-after';
// import ContactRelations from '../travel-details/contact-relations';

// import Relation from '../local-details/relation';
// import LocalDetailsInfos from '../local-details/local-infos';


import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../../store';
import * as ActionTypes from '../../../../store/types';

import {mapGetters, mapActions} from 'vuex';

const layoutName = 'overview_gridLayout';
const matchMobile = "only screen and (max-width: 700px)";

// import ArtistCalendarDate from './artist-calendar-date';
// import AddArtist from './add-artist';
// import AddTask from './add-task';
// import AddInvoiceLine from '../money-details/add-invoice-line';
// import CreateInvoice from '../money-details/create-invoice';

import { waitForAnimation } from '../../../../../../utility';
import { NotificationService } from '../../../../../../dt-plugins/notification/notification.service';
// import { isCalendarDateIdValid } from '../../../models/booking-overview.model';

export default {
  props: {
    selectedInvoice: Object
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    BoxWidget,
    Artists
  },
  data: function () {
    return {
      active: 0,
      e1: undefined,
      selected: null,
      isMobile: false,

      artistCalendarDateModalContainer: false,
      artistCalendarDateModal: false,
      artistCalendarDateProp: null,
      addArtistModalContainer: false,
      addArtistModal: false,

      addTaskModal: false,
      addTaskModalContainer: false,

      addInvoiceLineModal: false,
      addInvoiceLineModalConainer: false,

      createInvoiceModal: false,
      createInvoiceModalConainer: false,

      // MARK: Data
    };
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function(to, from) {
        if (to && to.query.calendar_date_artist_id) {
          this.artistCalendarDateProp = {
            calendarDateId: to.params.calendar_date_id,
            calendarDateArtistId: to.query.calendar_date_artist_id
          }

          this.artistCalendarDateModalContainer = true;
          setTimeout(() => {
            this.artistCalendarDateModal = true;
          }, 1);
        } else if (from && from.query.calendar_date_artist_id){
          this.artistCalendarDateModal = false;
          waitForAnimation(() => {
            this.artistCalendarDateModalContainer = false;
          })
        }

        if (to && to.query.modal === 'add_artist') {
          this.addArtistModalContainer = true;
          setTimeout(() => {
            this.addArtistModal = true;
          }, 1);
        } else if (from && from.query.modal === 'add_artist' && to.query.modal !== 'add_artist') {
          this.addArtistModal = false;
          waitForAnimation(() => {
            this.addArtistModalContainer = false;
          })
        }

        if (to && to.query.modal === 'add_task') {
          this.addTaskModalContainer = true;
          setTimeout(() => {
            this.addTaskModal = true;
          }, 1);
        } else if (from && from.query.modal === 'add_task' && to.query.modal !== 'add_task') {
          this.addTaskModal = false;
          waitForAnimation(() => {
            this.addTaskModalContainer = false;
          })
        }

        if (to && to.query.modal === 'add_invoice_line') {
          this.addInvoiceLineModalConainer = true;
          setTimeout(() => {
            this.addInvoiceLineModal = true;
          }, 1);
        } else if (from && from.query.modal === 'add_invoice_line' && to.query.modal !== 'add_invoice_line') {
          this.addInvoiceLineModal = false;
          waitForAnimation(() => {
            this.addInvoiceLineModalConainer = false;
          })
        }

        if (to && to.query.modal === 'create_invoice') {
          this.createInvoiceModalConainer = true;
          setTimeout(() => {
            this.createInvoiceModal = true;
          }, 1);
        } else if (from && from.query.modal === 'create_invoice' && to.query.modal !== 'create_invoice') {
          this.createInvoiceModal = false;
          waitForAnimation(() => {
            this.createInvoiceModalConainer = false;
          })
        }

      }
    }
  },
  computed: {
    ...mapGetters(storeNS, {
      gridLayout : layoutName,
      bookingOverview: 'bookingOverview',
      calendarDate: 'calendarDate',
      calendarDateId: 'calendarDateId',
      users: 'users',
      localDetailsConfirmedFlag: 'localDetailsConfirmedFlag',
      selectedInvoiceLines: 'selectedInvoiceLines'
    })
  },
  mounted: function() {
    window.onresize = this.windowResizeHandler;
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.UPDATE_LOCAL_DETAILS_CONFIRMED_FLAG]: ActionTypes.UPDATE_LOCAL_DETAILS_CONFIRMED_FLAG,
      [ActionTypes.LOAD_BOOKING_ARTIST]: ActionTypes.LOAD_BOOKING_ARTIST,
      [ActionTypes.TASKS.FETCH.ALL]: ActionTypes.TASKS.FETCH.ALL,
      [ActionTypes.SET_INVOICE_LINES]: ActionTypes.SET_INVOICE_LINES,
      [ActionTypes.FETCH_INVOICE_LINES]: ActionTypes.FETCH_INVOICE_LINES
    }),
    ...mapMutations(storeNS, {
      [ActionTypes.UPDATE_BOOKING_ARTIST]: ActionTypes.UPDATE_BOOKING_ARTIST
    }),
    selectBox: function (title) {
      this.$store.commit(`${storeNS}/${ActionTypes.SELECT_BOX}`, {layoutName, title});
    },
    onMinimize: function (title) {
      this.$store.commit(`${storeNS}/${ActionTypes.MINIMIZE_BOX}`, {layoutName, title});
      this.$refs.gridLayout.resizeEvent('resizeend');
    },
    onMaximize: function (title) {
      this.$store.commit(`${storeNS}/${ActionTypes.MAXIMIZE_BOX}`, {layoutName, title});
      this.$refs.gridLayout.resizeEvent('resizeend');
    },
    closeInvoiceDetails: function(event) {
      // this.$store.dispatch(`${storeNS}/${ActionTypes.CLOSE_INVOICE_DETAILS}`);
    },
    onBoxPinned: function({element, title}) {
      this.$store.commit(`${storeNS}/${ActionTypes.PIN_BOX}`, {layoutName, title, element});
    },
    windowResizeHandler: function(event) {
      // console.log(event);
      const width = window.innerWidth;
      const height = window.innerHeight;
      // console.log(width, height);

      // if(width < 1260) {
      //   console.log('Responsive Resolution');
      // } else {
      //   console.log('Normal Resolution');
      // }

      if (window.matchMedia(matchMobile).matches) {
        if (this.isMobile !== true) {
          this.toggleMobileLayout();
          this.isMobile = true;
        }
      } else {

        if (this.isMobile !== false) {
          this.isMobile = false;
          this.toggleNormalLayout();
        }

      }
    },
    toggleMobileLayout: function() {
      this.gridLayout.layout.forEach(l => {
        l.w = 60;
      });
      this.$refs.gridLayout.resizeEvent('resizeend');
    },
    toggleNormalLayout: function() {
      this.gridLayout.layout.forEach(l => {
          l.w = l.origW;
        });
      this.$refs.gridLayout.resizeEvent('resizeend');
    },
    onCheckboxChange: function(name, value) {
      switch(name) {
        case 'local_details_confirmed_flag': {
          this[ActionTypes.UPDATE_LOCAL_DETAILS_CONFIRMED_FLAG]({calendarDateId: this.calendarDateId, value: value.target.checked ? "1" : "0"})
          break;
        }
        default: {

        }
      }
    },
    onArtistCalendarDateSelected: function(artistCalendarDateId) {
      this.$router.push({name: this.$route.name, query: {calendar_date_artist_id: artistCalendarDateId, tab: 'performance_details' }});
      // this.artistCalendarDateModalContainer = true;
      // setTimeout(() => {
      //   this.artistCalendarDateModal = true;
      // }, 0);
    },
    onArtistCalendarDateModalCancel: function(event) {
      this.$router.push({name: this.$route.name, query: {calendar_date_artist_id: undefined}});
    },
    onArtistCalendarDone: function(calendarDateArtist) {
      console.log(calendarDateArtist);
      this[ActionTypes.UPDATE_BOOKING_ARTIST]({calendarDateArtist})
      this.$router.push({name: this.$route.name, query: {calendar_date_artist_id: undefined}});
    },
    addArtistModalDone: function(res) {
      this.addArtistModalCancelled();
      this[ActionTypes.LOAD_BOOKING_ARTIST]({artists: res.data.artists});
    },
    addArtistModalCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined
        }
      });
    },
    onAddTaskDone: function() {
      this.addTaskModalCancelled();
      this[ActionTypes.TASKS.FETCH.ALL]({});
    },
    addTaskModalCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined
        }
      });
    },
    addInvoiceLineModalCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined
        }
      });
    },
    doneAddInvoiceLine: function(res) {
      console.log(res);
      this.addInvoiceLineModalCancelled();
      this[ActionTypes.SET_INVOICE_LINES](res.data);
    },
    onCreateInvoiceCreate: function() {
      if (!this.checkForSelectedInvoiceLines()) {
        return;
      }
      
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: 'create_invoice'
        }
      });
    },
    checkForSelectedInvoiceLines: function() {
      if (this.selectedInvoiceLines && this.selectedInvoiceLines.size > 0) {
        return true;
      } else {
        NotificationService.showNotification({
          text: 'Please select what should be invoiced',
          timeout: 5000,
          color: 'error'
        })
        return false;
      }
    },
    createInvoiceModalCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          modal: undefined
        }
      });
    },
    doneCreateInvoice: function() {
      this.createInvoiceModalCancelled();
      this[ActionTypes.FETCH_INVOICE_LINES]({});
    },

    onSendDocumentAndFilesClick: function(event) {
      if (isCalendarDateIdValid(this.calendarDateId, true)) {
        this.$router.push({
          ...this.$route, 
          query: {
            ...this.$route.query,
            modal: 'send_doc_files',
            calendar_date_id: this.calendarDateId
          }
        });
      }
    }

    // MARK: Methods
  }
};

</script>

<style lang="scss" scoped>
  .dt-sidenav-tab{
    transition: 200ms ease-out;
    &.LOADING {
      opacity: 0.50;
    }
  }


  .create-invoice-section {
    text-align: right;
    margin-top: 20px;
    margin-right: -10px;
  }


  .local-details-confirmed {
    display: flex;
    background: white;
    padding: 10px 5px;
    border-radius: 2px;

    .label {
      flex: 1;
    }
    .checkbox {
      flex: 1;
      margin-top: 4px; 
    }
  }


</style>
